import {
  LocaleEnum,
  Metadata,
  SalaryStatsDocument,
  SalaryStatsQuery,
  SalaryStatsQueryVariables,
  SalaryStats,
} from 'generated/apolloComponents'
import CustomHead from '@/components/molecules/CustomHead'
import SalaryReportTemplate from '@/components/templates/SalaryReport'
import { serviceClient } from '@/api/apollo'

type Props = {
  data: SalaryStats
}

const ItReport = ({ data }: Props) => {
  const metaData: Metadata = {
    title: data.title,
    description: data.description,
  }
  return (
    <>
      <CustomHead metaData={metaData} />
      <SalaryReportTemplate statsData={data} />
    </>
  )
}

export const getServerSideProps = async (context: any) => {
  const pageData = await serviceClient.query<
    SalaryStatsQuery,
    SalaryStatsQueryVariables
  >({
    query: SalaryStatsDocument,
    variables: {
      id: context.params?.slug,
      language: LocaleEnum[context.locale as 'pl' | 'en'],
    },
    fetchPolicy: 'no-cache',
  })

  if (pageData.errors) {
    return {
      notFound: true,
    }
  }

  // context.res.setHeader(
  //   'Cache-Control',
  //   'public, s-maxage=86400, stale-while-revalidate=86400'
  // )

  return {
    props: {
      data: pageData.data.salaryStats,
    },
  }
}

export default ItReport
